/** Owner-approved additions only (2026-10-28), not a global ROW opening. */
export const ADDED_SHIPPING_COUNTRIES = [
  "CA", "AX", "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
  "DK", "EE", "FO", "FI", "FR", "DE", "GI", "GR", "GG", "HU", "IS", "IE",
  "IM", "IT", "JE", "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME",
  "NL", "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI", "ES",
  "SJ", "SE", "CH", "UA", "GB", "VA", "AR", "BO", "BR", "CL", "CO", "EC",
  "FK", "GF", "GY", "PY", "PE", "SR", "UY", "VE",
] as const;

export type AddedShippingCountry = typeof ADDED_SHIPPING_COUNTRIES[number];

export function isAddedShippingCountry(code: string): code is AddedShippingCountry {
  return (ADDED_SHIPPING_COUNTRIES as readonly string[]).includes(code);
}

/** Public policy mirror, not a Shopify rate/price override. Shopify charges at checkout. */
export const INTERNATIONAL_SHIPPING_POLICY = {
  currency: "USD", standard: 125, freeSubtotal: 350, minBusinessDays: 5, maxBusinessDays: 7,
} as const;

/** Only USD after-discount/pre-tax subtotals can be compared with this policy. */
export function internationalShippingCharge(subtotal: number, currency: string): number | null {
  if (currency !== INTERNATIONAL_SHIPPING_POLICY.currency || !Number.isFinite(subtotal) || subtotal < 0) return null;
  return subtotal >= INTERNATIONAL_SHIPPING_POLICY.freeSubtotal ? 0 : INTERNATIONAL_SHIPPING_POLICY.standard;
}

/** Added destinations must never buy using Shopify's inactive-market fallback context. */
export function matchesAddedCountryPricing(
  country: string, resolvedCountry: unknown, currency: unknown,
): boolean {
  return isAddedShippingCountry(country) && resolvedCountry === country &&
    typeof currency === "string" && /^[A-Z]{3}$/.test(currency);
}